import { ApplicationConfig, inject, LOCALE_ID, provideAppInitializer, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core'
import { provideRouter } from '@angular/router'
import { appRoutes } from './app.routes'
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http'
import { includeBearerTokenInterceptor } from 'keycloak-angular'
import { provideKeycloakAngular } from './keycloak.config'
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async'
import { MAT_DATE_LOCALE } from '@angular/material/core'
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field'
import { registerLocaleData } from '@angular/common'
import localeDe from '@angular/common/locales/de'
import localeDeExtra from '@angular/common/locales/extra/de'
import { provideToastConfig } from './hot-toast.config'
import { provideQuill } from './quill.config'
import { provideLuxonDateAdapter } from '@angular/material-luxon-adapter'
import { provideTranslateConfig } from './translate.config'
import { ENVIRONMENT } from '@open-event/shared'
import { environment } from '../environments/environment'
import { provideServiceConfig } from './service.config'

registerLocaleData(localeDe, 'de-DE', localeDeExtra)

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimationsAsync(),
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideLuxonDateAdapter(),
    { provide: MAT_DATE_LOCALE, useValue: 'de-DE' },
    { provide: LOCALE_ID, useValue: 'de-DE' },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },
    provideToastConfig(),
    provideKeycloakAngular(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withXhr(), withInterceptors([includeBearerTokenInterceptor])),
    provideTranslateConfig(),
    provideQuill(),
    provideRouter(appRoutes),
    { provide: ENVIRONMENT, useValue: environment },
    provideAppInitializer(async () => {
      const runtimeEnvironment = inject(ENVIRONMENT)
      try {
        const config = await (await fetch('/config.json')).json()
        runtimeEnvironment.maps = { apiKey: config.mapsApiKey }
      } catch {
        runtimeEnvironment.maps = { apiKey: '' }
      }
    }),
    provideServiceConfig()
  ]
}
